import React from 'react';
import { useDispatch } from 'react-redux';

import EditIcon from '@mui/icons-material/Edit';
import { Grid, useTheme } from '@mui/material';

import GridItem from 'components/GridItem';
import { CLIENT_MODAL, projectModalActions } from 'features/Project/projectModalSlice';
import { ClientProjectResponse } from 'types/ProjectTypes';
interface ClientLineItemProps {
  clientData: ClientProjectResponse;
  projectClients: ClientProjectResponse[];
}

const ClientLineItem = ({ clientData, projectClients }: ClientLineItemProps) => {
  const theme = useTheme();
  const dispatch = useDispatch();
  const { full_name: fullName, phone, email, id, position, client } = clientData;

  const editHandler = async (clientId: string) => {
    const clientDetails = projectClients?.find((item) => item.id === clientId);

    if (clientDetails) {
      dispatch(
        projectModalActions.openEditModal({
          type: CLIENT_MODAL,
          data: {
            id: clientDetails.id,
            client: clientDetails.client.client_id,
            email: clientDetails.email,
            full_name: clientDetails.full_name,
            position: clientDetails.position,
            phone: clientDetails.phone,
          },
        }),
      );
    }
  };

  return (
    <Grid
      container
      sx={{
        mb: 0.1,
        border: 1,
        height: '52px',
        alignItems: 'center',
        borderColor: theme.palette.background.default,
        ':hover': {
          backgroundColor: theme.palette.primary.contrastText,
          cursor: 'pointer',
        },
      }}>
      <GridItem title={client.client_name} seenOrIsHeading={false} breakpoint={4} />
      <GridItem title={position} seenOrIsHeading={false} breakpoint={1} />
      <GridItem title={fullName} seenOrIsHeading={false} breakpoint={1} />
      <GridItem title={email} seenOrIsHeading={false} breakpoint={1} />
      <GridItem title={phone} seenOrIsHeading={false} breakpoint={1} />
      <GridItem
        title={<EditIcon aria-describedby={id} sx={{ color: '#9e9e9e' }} onClick={() => editHandler(id)} />}
        seenOrIsHeading={false}
        breakpoint={1}
      />
    </Grid>
  );
};

export default ClientLineItem;
